export enum ErrorCode {
  PermissionError = 'TSWP00000100E',
  FeatureBookingError = 'TSWP00000200E',
  ChannelError = 'TSWP00000300E',
  IdentityError = 'TSWP00000400E',
  BootstrapError = 'TSWP00000500E',
  ProductFeatureError = 'TSWP00000600E',
}
